export default function PurchasingSteps() {
    return {
        title: 'Conducting a policy review is Easy',
        headline:'If the review reveals an underperforming policy, we’ll analyze what it will take to get the policy back in "good health".  In addition, we’ll review alternative solutions in the marketplace to see if there’s solution that more closely aligns with the client’s current goals.',
        steps: [
            'Complete the policy review request including your client’s current health assessment and your coverage needs analysis.',
            'Have owner sign in-force illustration request.',
            'Receive and review policy review report.',
        ],
        secondHeadline:'The following are some of the important factors to consider in evaluating whether your client should surrender or exchange their existing policy for a new policy:',
        paragraphs:[
            'Surrender charges may be due on an exchange of one contract for another',
            'A change in policy may require a physical examination',
            'If your client is not in good health, premiums for a new policy may be higher or they may not qualify for coverage at all',
            'Any new policy is also likely to have a new contestability period',
            'Surrenders may be taxable. Your client should consult their own tax advisors regarding any liability on surrenders or exchanges of existing policies'
        ]
    }
}


// WEBPACK FOOTER //
// ./src/components/Common/data/policy-review/PurchasingSteps.js